import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainNavbar = _resolveComponent("MainNavbar")!
  const _component_MainBanner = _resolveComponent("MainBanner")!
  const _component_FeaturedCourse = _resolveComponent("FeaturedCourse")!
  const _component_FAQ = _resolveComponent("FAQ")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainNavbar),
    _createVNode(_component_MainBanner),
    _createVNode(_component_FeaturedCourse),
    _createVNode(_component_FAQ),
    _createVNode(_component_MainFooter)
  ], 64))
}